export function timeHandler(time) {
  if (isNaN(Number(time))) {
    return false;
  }
  if (~~time == 0) {
    time = new Date(t.replace(/\s/g, 'T')).getTime() / 1000;
    time -= 60 * 60 * 8;
  }
  var timeSpan = time * 1000;
  var dateTime = new Date(parseInt(timeSpan));
  var year = dateTime.getFullYear();
  var month = dateTime.getMonth() + 1;
  var day = dateTime.getDate();

  var now = new Date();
  var now_new = Date.parse(now);
  var ms = now_new - timeSpan;
  var timeSpanStr;

  var time_suffix;

  if (ms > 0) {
    time_suffix = '前';
  } else {
    ms = Math.abs(ms);
    time_suffix = '后';
  }

  if (ms <= 1000 * 60 * 1) {
    timeSpanStr = Math.round(ms / 1000) + '秒' + time_suffix;
  } else if (1000 * 60 * 1 < ms && ms <= 1000 * 60 * 60) {
    timeSpanStr = Math.round(ms / (1000 * 60)) + '分钟' + time_suffix;
  } else if (1000 * 60 * 60 * 1 < ms && ms <= 1000 * 60 * 60 * 24) {
    timeSpanStr = Math.round(ms / (1000 * 60 * 60)) + '小时' + time_suffix;
  } else if (1000 * 60 * 60 * 24 < ms && ms <= 1000 * 60 * 60 * 24 * 7) {
    timeSpanStr = Math.round(ms / (1000 * 60 * 60 * 24)) + '天' + time_suffix;
  } else {
    timeSpanStr = year + '-' + month + '-' + day;
  }
  return timeSpanStr;
}
